import styled from "styled-components";
import * as G from "~/components/global.style";

export const MainProductLink = styled.div`
   i{
        font-size: 24px;
        float: left;
   }
   a{
        display: block;
        padding-left: 10px;
        margin-top: 0px;
        float: left;
   }
`;
export const ParentElement = styled.div`
    i{
        font-size: 24px;
        float: left;
    }
    p{
        display: block;
        padding-left: 10px;
        margin-top: 0px;
        float: left;
        margin-bottom: 0;
    }
`;

export const ListCommandBar  = styled.div`
    height: 59px;
    .ms-SearchBox{
        height: 100%
    }
    .ms-SearchBox-field{
        width: 224px;
    }
    .ms-TextField-field
    {
        width: 224px;
    }

    .ms-CommandBar{
        .ms-OverflowSet-item{
            background: white;
            button.ms-Button{
                background :white;                
            }
            button.is-checked{
                background: ${G.ActiveColor};
            }
            &:not(:last-child) {
             margin-right: 10px;
            }
        }
    }
    .ms-CommandBar{
        background: transparent;
        padding-right: 5px;
        .ms-CommandBar-primaryCommand{
            position: absolute;

            .ms-OverflowSet-item{
                position: absolute;
                height: 40px;
                left: -13px;
                padding: 10px;
                top: -14px;
                
                button{
                    border: 1px solid ${G.PrimaryColor};
                    color: ${G.PrimaryColor};
                }
                &:nth-child(2){
                    background: transparent;
                    padding: 10px 0;
                    left: 187px;
                    i{
                        color: white;
                    }
                    button{
                        padding: 10px;
                        background: ${G.PrimaryColor};
                        color: white;
                    }
                }
                &:first-child{
                    &:before{
                        content: "";
                        position: absolute;
                        display: block;
                        bottom: -27px;
                        border-left: 15px solid transparent;
                        border-top: 15px solid white;
                        border-right: 15px solid transparent;
                        border-bottom: 15px solid transparent;
                        left: 4px;
                    }
                }
            }
        }

        .ms-CommandBar-secondaryCommand{
            margin-left: auto;
        }
    }

    #newProductTemplate{
        height: 40px;
        line-height: 40px;
        > span{
            height: inherit;
            line-height: inherit;
        }
    }
`;


export const DetailListStyle = styled.div`
    .ms-DetailsRow-cell{
        font-size: 14px;
        color: black;
    }
    .ms-DeailsRow{
        &.is-selected{
            background: ${G.ActiveColor};
        }
    }
    .ms-DetailsRow-cell{
        min-height: 30px;
        display: inline-flex;
        align-items: center;
        padding-bottom: 3px;
        padding-top: 3px;
    }
    .ms-DetailsRow-check{
        opacity: 1;
    }
    .ms-DetailsHeader-cell,.checkbox-square{
        .ms-Check{
            border: 1px solid ${G.PrimaryColor};
            background: white;
            width: 15px;
            height: 15px;
            line-height: 12px;
            &.is-checked{
                background:  ${G.PrimaryColor};
            }
            .ms-Check-circle{
                opacity: 0;
            }
            .ms-Check-check{
                width: 15px;
                height: 15px;
            }
        }
    }
    .status-New{
        i{
            color: ${G.ColorUnAvailable}
        }
    }
    .status-Working{
        i{
            color: ${G.ColorWaiting}
        }
    }
    .status-Ready{
        i{
            color: ${G.ColorAvailable}
        }
    }
    .status-Discontinued{
        i{
            color: ${G.ColorUnAvailable}
        }
    }
`;

export const StatusStyleReady = styled.div`
    font-size: 25px;
    color: ${G.ColorAvailable};
`;

export const StatusStyleNew = styled.div`
    font-size: 25px;
    color: ${G.ColorUnAvailable};
`;

export const StatusStyleWait = styled.div`
    font-size: 25px;
    color: ${G.ColorWaiting};
`;



// WEBPACK FOOTER //
// ./src/components/product/products.style.ts